import React, { useState } from "react";
import { Cropper } from "../../Other/Cropper/Cropper";
import { Loading } from "../../Other/Loading";
import { useDispatch } from "react-redux";
import { userService } from "../../../_services";
import { userConstants } from "../../../_constants";
import axiosInstance from "../../../axios";

export const UploadAvatar = ({ hideUploadAvatar }) => {
  const { REACT_APP_LOGIN_API_BASEURL } = process.env;
  const dispatch = useDispatch();
  const [src, setSrc] = useState(null);
  const [loader, setLoader] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = async (event) => {
    try {
      if (event.target.files && event.target.files[0]) {
        const file = event.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("file", file);
        // formData.append("courseId", courseId); // Add if needed

        setSrc(file.name); // show filename while uploading

        const res = await axiosInstance.post(
          `${REACT_APP_LOGIN_API_BASEURL}/image`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        //console.log("res--", res);
        setSrc(res?.data?.url); // set uploaded image URL
      } else {
        hideUploadAvatar(false);
      }
    } catch (err) {
      console.error("Upload failed", err);
      setErrorMsg("Upload failed. Please try again.");
      setLoader(false);
    }
  };

  const clickCancel = () => {
    hideUploadAvatar(false);
  };

  const uploadProfileImage = async (base64) => {
   
    if (base64) {
      try {
        setLoader(true);

        await axiosInstance.post("user/profile/image", {
          base64: base64,
          fileName: "profile",
        });

        const { data } = await userService.getUserInfo();

        dispatch({
          type: userConstants.GET_USER_INFO,
          payload: data.data,
        });

      } catch (error) {
        console.error("Failed to upload profile image or fetch user info", error);
        // Optionally: set error state or show toast
      } finally {
        hideUploadAvatar(false);
        setLoader(false);
      }
    }
  };


  return (
    <>
      {loader ? (
        <Loading />
      ) : (
        <div className="upload-avatar">
          {!src ? (
            <div className="upload-section">
              <h4 className="header">
                Accepted avatars formats are PNG, JPG, JPEG and GIF
              </h4>
              <div className="upload-icon">
                <input
                  id="avatar"
                  className=""
                  type="file"
                  value=""
                  onChange={handleChange}
                ></input>
              </div>
              <h4>Drag and drop or browse to choose a file</h4>
            </div>
          ) : (
            <div className="preview-section">
              <Cropper
                src={src}
                getBlob={uploadProfileImage}
                closeCropper={clickCancel}
              />
            </div>
          )}
        </div>
      )}
      {errorMsg && <p className="text-red-500 text-xs">{errorMsg}</p>}
    </>
  );
};
